class Menu {
    constructor(menuID, hamburgerID) {
		this.mouseIsOverShareMenu = false;
    	this.mouseIsOverSearchForm = false;
    	this.searchInputInFocus = false;
		this.nav = document.getElementById(menuID);
		this.hamburger = document.getElementById(hamburgerID);
		if (this.nav) this.menuItems = this.nav.querySelectorAll('a');
		
		this.init();
    }

    init() {
		this.windowScrollWatch();
		this.hamburgerClickWatch();
		this.mobileOverlayClickWatch();
		this.mobileToggleSubmenuClickWatch();
		this.mobileCloseSubmenuClickWatch();
		this.mobileToggleSubSubmenuClickWatch();
		this.menuItemsClickWatch();
		this.submenuClickWatch();
		this.share();
		this.search();

	}
	
	submenuClickWatch(){

		$('.menu-item-has-children > .menu-item-depth-1').on('click', (e)=>{
			if(window.innerWidth > 1199){
				e.preventDefault();
			}
		});
	}

    windowScrollWatch(){
		if (!this.nav) return;
	}

    hamburgerClickWatch(){
		
		if (!this.hamburger) return;
		
		/* toggle css class "is-active" on click */
		this.hamburger.addEventListener('click', ()=>{
			this.hamburger.classList.toggle('is-active');
			document.body.classList.toggle('menu-is-open');

			let searchFormInputMobile = document.querySelector('#search-form-mobile input[type="text"]');

			if (searchFormInputMobile){
				searchFormInputMobile.value = '';
			}

			let activeSubmenu = document.querySelectorAll('.active-submenu');
			if (activeSubmenu){

				Array.from(activeSubmenu).forEach( ( elem )=>{
					elem.classList.remove('active-submenu');
				} );
			}
		});

	}

	menuItemsClickWatch(){
		if (!this.menuItems) return;
	}

	mobileOverlayClickWatch(){
		if (!this.hamburger) return;

		/* Main Screen overlay */
		let mobileOverlay = document.getElementById('nav-mobile-overlay');
		if (!mobileOverlay) return;
		mobileOverlay.addEventListener('click',()=>{
			this.hamburger.click();
		});

		/* Small screen overlay for navigation area */
		let smallMabileOverlay = document.getElementById('nav-mobile-overlay-2');
		if (!smallMabileOverlay) return;
		smallMabileOverlay.addEventListener('click',()=>{
			this.hamburger.click();
		});

	}

	mobileToggleSubmenuClickWatch(){
		let submenuTogglers = document.querySelectorAll('.menu-item-has-children > .menu-item-depth-0');

		if (!submenuTogglers.length) return;

		for (var elem of submenuTogglers) {
			let _self = elem;
			elem.addEventListener('click', (event)=>{
				if(window.innerWidth < 1200){
					event.preventDefault();
					_self.parentNode.querySelector('.sub-menu-wrap').classList.add('active-submenu');
				}
			})
		}
	}

	mobileToggleSubSubmenuClickWatch(){
		let submenuTogglers = document.querySelectorAll('.menu-item-has-children > .menu-item-depth-1');

		if (!submenuTogglers.length) return;

		for (var elem of submenuTogglers) {
			let _self = elem;
			elem.addEventListener('click', (event)=>{
				event.preventDefault();
				if(window.innerWidth > 1199){
					$(event.currentTarget).siblings('ul').slideToggle();
					$(event.currentTarget).siblings('i').toggleClass('is-open');
				}else
					_self.parentNode.querySelector('.sub-menu').classList.add('active-submenu');
			})
		}
	}

	mobileCloseSubmenuClickWatch(){
		let submenuCloseBtn = document.querySelectorAll('.submenu-header__back');

		if (!submenuCloseBtn.length) return;
		for ( let elem of submenuCloseBtn ){
			elem.addEventListener('click', ()=>{
				elem.parentNode.parentNode.parentNode.classList.remove('active-submenu');
				elem.parentNode.parentNode.classList.remove('active-submenu');
			})
		}
	}

	share(){
		let shareBtn = document.getElementById('share-btn');
		let shareMenu = document.getElementById('share-menu');

		if (!shareBtn) return;

		if (!shareMenu) return;

		let checkAndHideShareMenu = () => {
			setTimeout(()=>{
				if ( this.mouseIsOverShareMenu === false ){
					shareMenu.classList.remove('is-active');
				}
			}, 500)
		}

		shareBtn.addEventListener('click', ()=>{
			this.mouseIsOverShareMenu = true;
			shareMenu.classList.toggle('is-active');
		});

		shareBtn.addEventListener('mouseleave', (e)=>{
			this.mouseIsOverShareMenu = false;
			checkAndHideShareMenu();
		});

		shareMenu.addEventListener('mouseleave', (e)=>{
			this.mouseIsOverShareMenu = false;
			checkAndHideShareMenu();
		});

		shareMenu.addEventListener('mouseenter', (e)=>{
			this.mouseIsOverShareMenu = true;
		});
	}

	search(){
		let searchBtn = document.getElementById('search-btn');
		let searchFormWrap = document.getElementById('search-form-wrap');

		let searchForm = document.getElementById('search-form');
		let searchFormInput = searchForm ? searchForm.querySelector('input[type="text"]') : null;
		let searchFormBtn = searchForm ? searchForm.querySelector('button') : null;

		let searchFormMobile = document.getElementById('search-form-mobile');
		let searchFormInputMobile = searchFormMobile ? searchFormMobile.querySelector('input[type="text"]') : null;
		let searchFormBtnMobile = searchFormMobile ? searchFormMobile.querySelector('button') : null;

		if (!searchBtn) return;

		if (!searchFormWrap) return;

		if (!searchForm) return;

		if (!searchFormInput) return;

		if (!searchFormBtn) return;

		if ( searchFormInput.value.length > 2 )
			searchFormBtn.disabled = false;

		let checkAndHideForm = () => {
			setTimeout(()=>{
				if ( this.mouseIsOverSearchForm === false && this.searchInputInFocus === false){
					searchFormWrap.classList.remove('is-active');
					searchBtn.classList.remove('is-opened');
					searchFormInput.value = '';
				}
			}, 500)
		}

		let setSearchBtnState = () => {
			if ( searchFormInput.value.length > 2 )
				searchFormBtn.disabled = false;
			else
				searchFormBtn.disabled = true;
		}

		let setSearchBtnStateMobile = () => {
			if ( searchFormInputMobile.value.length > 2 )
				searchFormBtnMobile.disabled = false;
			else
				searchFormBtnMobile.disabled = true;
		}

		searchBtn.addEventListener('click', (e)=>{
			this.mouseIsOverSearchForm = true;
			setSearchBtnState();
			searchFormWrap.classList.toggle('is-active');
			searchFormInput.focus();
			searchBtn.classList.toggle('is-opened');

		});

		searchBtn.addEventListener('mouseleave', (e)=>{
			this.mouseIsOverSearchForm = false;
			checkAndHideForm();
		});

		searchForm.addEventListener('mouseleave', (e)=>{
			this.mouseIsOverSearchForm = false;
			checkAndHideForm();
		});

		searchForm.addEventListener('mouseenter', (e)=>{
			this.mouseIsOverSearchForm = true;
		});

		searchFormInput.addEventListener('focus', (e)=>{
			this.searchInputInFocus = true;
			setSearchBtnState();
		});

		searchFormInput.addEventListener('input', (e)=>{
			setSearchBtnState();
		});

		searchFormInput.addEventListener('blur', (e)=>{
			this.searchInputInFocus = false;
			checkAndHideForm();
		});

		if (!searchFormMobile) return;

		if (!searchFormInputMobile) return;

		if (!searchFormBtnMobile) return;

		searchFormInputMobile.addEventListener('input', (e)=>{
			setSearchBtnStateMobile();
		});

	}
}

export default Menu;



// WEBPACK FOOTER //
// ./scripts/modules/menu.js